import Date from '@/modules/AdminTools/components/Form/Date';

const EndOn = () => <Date name={'end_on'} label={'End Date'} />;

export default EndOn;
